import { Expose } from 'class-transformer';
import { MooringArticleCategory } from './MooringArticleCategory';
import { MooringProductTypeDto } from './MooringProductType';

@Expose()
export class MooringArticleType {
  static ApiUrl = 'api/mooring-article-types';

  Id!: number;
  Name!: string;
  NameEn!: string;
  NameEs!: string;

  CategoryId!: number;
  Category?: MooringArticleCategory;

  VariantId!: ArticleTypeVariant;
  Variant?: MooringArticleTypeVariant;

  AquacomId?: number;
}

@Expose()
export class AquacomComponentType {
  Id!: number;
  Name!: string;

  CategoryId!: number;
  CategoryName!: string;
}

@Expose()
export class MooringArticleTypeDto {
  Id!: number;
  Name!: string;
  NameEn!: string;
  NameEs!: string;

  CategoryId!: number;

  AquacomId?: number;

  ProductTypes!: MooringProductTypeDto[];
}
export const ArticleTypeVariant = {
  DEFAULT: 0,
  ANCHOR_PLOW: 1,
  ANCHOR_AC_14: 2,
  ANCHOR_ADA: 3,
  CHAIN_BOTTOM: 4,
  CHAIN_GALV: 5,
  STRAP_MAIN: 6,
  STRAP_SECONDARY: 7,
  STRAP_BUOY: 8,
  STRAP_ANCHOR_LINE: 9,
  STRAP_BRIDLE: 10,
  ROPE_THREE_STRAND: 11,
  ROPE_EIGHT_STRAND: 12,
  SHACKLE_MOORING: 13,
  RING_OVAL: 14,
  CONNECTION_ASEKE: 15,
  ROPE_TROSSE: 16,
  KAUSE_M_OVAL_RING: 17,
  KAUSE_PIPE: 18,
  BUOY_ACTIVA: 19,
  BUOY_APB: 20,
  BUOY_AQUA: 21,
  MOORING_BOLT: 22,
  FLEXILINK: 23,
  SOLIDLINK: 24,
  KAUSE_W_RING_AND_EAR: 25,
  STRAP_GRID: 26,
} as const;

const strapVariants = [
  ArticleTypeVariant.STRAP_MAIN,
  ArticleTypeVariant.STRAP_SECONDARY,
  ArticleTypeVariant.STRAP_BUOY,
  ArticleTypeVariant.STRAP_ANCHOR_LINE,
  ArticleTypeVariant.STRAP_BRIDLE,
  ArticleTypeVariant.STRAP_GRID,
];

export const isStrapArticleType = (type: ArticleTypeVariant) => {
  return !!strapVariants.find((item) => item === type);
};

export type ArticleTypeVariant = (typeof ArticleTypeVariant)[keyof typeof ArticleTypeVariant];

@Expose()
export class MooringArticleTypeVariant {
  Id!: number;
  Name!: string;
  NameEn!: string;
  NameEs!: string;
  Type!: ArticleTypeVariant;
}
